import type { ReactNode } from 'react';

import { periodicFormOptions } from '@/entities/(notification)/periodic';
import { withForm } from '@/shared/ui/form';

import { PeriodicFormPanel } from './periodic-form-panel';

export const PeriodicFormContent = withForm({
  ...periodicFormOptions,
  props: {
    workspaceId: '',
    renderFooter: undefined as (() => ReactNode) | undefined,
  },
  render: function PeriodicFormContent({ form, workspaceId, renderFooter }) {
    return (
      <div className="flex h-full gap-6 px-4 pb-6">
        <PeriodicFormPanel
          form={form}
          workspaceId={workspaceId}
          renderFooter={renderFooter}
        />
      </div>
    );
  },
});
